module.exports = __webpack_public_path__ + "media/images/credit_points_ready_for_download-72fd906ce130df3dd331f742f8842388.jpg";